import React from 'react'

import { Progress } from 'antd'
import { HStack, Link, Text, VStack } from 'govwell-ui'
import { AICommunityAssistantUsageQuotaStatus } from 'types/graphql'

import AIAssistantUpsellModal from 'src/components/AIAssistant/AIAssistantUpsellModal'
import { useAICommunityAssistantUsageQuery } from 'src/fetch/aiChat'
import useDisclosure from 'src/hooks/use-disclosure'
import { useMyOrgId } from 'src/layouts/AppStateContextLayout/utils'

const ProgressBarColorForQuotaStatusMap: Record<AICommunityAssistantUsageQuotaStatus, string> = {
  UnderQuota: 'var(--color-blue-500)',
  NearOrAtQuota: 'var(--color-yellow-500)',
  OverQuota: 'var(--color-red-500)',
}

const AICommunityAssistantUsageFooter = () => {
  const organizationId = useMyOrgId()
  const { aiCommunityAssistantUsage } = useAICommunityAssistantUsageQuery({
    organizationId,
    date: { type: 'ThisMonth' },
  })

  const upsellModalState = useDisclosure()

  if (!aiCommunityAssistantUsage?.quotaDetails) {
    return null
  }

  const isOverQuota = aiCommunityAssistantUsage.quotaDetails.status === 'OverQuota'

  return (
    <VStack>
      <Progress
        percent={aiCommunityAssistantUsage.quotaDetails.percentUsed}
        showInfo={false}
        strokeColor={
          ProgressBarColorForQuotaStatusMap[aiCommunityAssistantUsage.quotaDetails.status]
        }
        className="m-0"
      />
      <HStack gap={2} align="center" className="px-3 py-1.5">
        <Text.Body>
          <strong>{aiCommunityAssistantUsage.quotaDetails.usedResponses}</strong>/
          {aiCommunityAssistantUsage.quotaDetails.allowedResponses} AI responses used this month
        </Text.Body>
        <span className="text-gray-400">·</span>
        <Link onClick={upsellModalState.open}>
          {isOverQuota ? 'Upgrade to continue access' : 'Get unlimited responses'}
        </Link>
      </HStack>
      <AIAssistantUpsellModal
        isOpen={upsellModalState.isOpen}
        onClose={upsellModalState.close}
        tiers={aiCommunityAssistantUsage.tiers}
      />
    </VStack>
  )
}

export default React.memo(AICommunityAssistantUsageFooter)
